'use client';
import { jsx } from 'react/jsx-runtime';
import { BaseTrigger } from './base-trigger.component.js';
import { useSwanPopover } from './popover.context.js';

function PopoverTrigger({ children: t }) {
    let { triggerRef: p, triggerProps: i = {} } = useSwanPopover();
    return jsx(BaseTrigger, {
        triggerRef: p,
        triggerProps: i,
        removeAriaExpanded: true,
        children: t
    });
}

export { PopoverTrigger };
